import Joi from 'joi';
import _ from 'lodash';
import { TGiftPackageType } from '../../generated/graphql';
import { clearableField } from '../shared/clearableField';

export const getGiftPackageSchema = () => {
  const schema = Joi.object()
    .unknown(false)
    .keys({
      id: Joi.forbidden(),
      companyId: clearableField(Joi.string().trim()),
      name: Joi.string().trim().required(),
      products: Joi.array().required(),
      isDefault: clearableField(Joi.boolean()),
      type: Joi.string()
        .trim()
        .valid(...Object.values(TGiftPackageType)),
      subType: clearableField(
        Joi.string().trim().valid(
          //Work Anniversary Variatons
          'deluxe',
          'brickOnly',
          'custom',
          'legoOnly',
          'mini',
          //child Birthday Variations
          'child1',
          'child2',
          'child3',
          'child4',
          'child5',
          'child6',
          'child7',
          'child8',
          'child9',
          'child10to14',
          'child15to18',
          //One Off Variations
          'babyGift',
          'carePackage',
          'replacementEmployeeBirthday',
          'replacementWorkAnniversary',
          'wedding'
        )
      )
    });

  return schema;
};

export const getGiftPackagesDefaultValues = (product?: Record<string, any> | null) => {
  return _.pick(product || {}, ['name', 'products', 'type']);
};
